module.exports = __webpack_public_path__ + "assets/icons/not-hazardous.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/icon/not-hazardous.png
// module id = ./src/styles/icons/icon/not-hazardous.png
// module chunks = 0